interface AdCopyIconProps {
  className?: string,
  fillColor: string,
  height: number | string,
  width: number | string,
}

const AdCopyIcon = (props: AdCopyIconProps) => {
  const {
    className, fillColor, height, width,
  } = props

  return (
    <svg className={className} viewBox="0 0 40 40" style={{ width, height }}>
      <path
        style={{ fill: fillColor }}
        d="M28.5,9.7l-1-3.1c-0.1-0.3-0.4-0.5-0.7-0.5c-0.3,0-0.6,0.2-0.6,0.6l-4.3,17.7L21.3,25l-0.2-0.7l4.3-17.7
            c0.1-0.4-0.1-0.7-0.5-0.9c-0.4-0.1-0.7,0.1-0.9,0.5l-4.4,17.8c0,0.1,0,0.2,0,0.3l0.6,2.3c0.1,0.3,0.4,0.6,0.7,0.6c0.1,0,0.1,0,0.2,0
            c0.2-0.1,0.4-0.2,0.5-0.4l1.5-1.7c0.1-0.1,0.1-0.2,0.1-0.3l3.8-15.5l0.3,0.9c0.1,0.4,0.5,0.6,0.9,0.4C28.4,10.4,28.6,10.1,28.5,9.7z
            "
      />
      <path
        style={{ fill: fillColor }}
        d="M27.3,31.8H11.1c-0.4,0-0.7,0.3-0.7,0.7c0,0.4,0.3,0.7,0.7,0.7h16.1c0.4,0,0.7-0.3,0.7-0.7
            C27.9,32.1,27.6,31.8,27.3,31.8z"
      />
      <path
        style={{ fill: fillColor }}
        d="M27.3,29H11.1c-0.4,0-0.7,0.3-0.7,0.7s0.3,0.7,0.7,0.7h16.1c0.4,0,0.7-0.3,0.7-0.7S27.6,29,27.3,29z"
      />
      <path
        style={{ fill: fillColor }}
        d="M11.1,27.6h7.4c0.4,0,0.7-0.3,0.7-0.7s-0.3-0.7-0.7-0.7h-7.4c-0.4-0.1-0.7,0.2-0.7,0.6
            C10.5,27.2,10.8,27.6,11.1,27.6z"
      />
    </svg>
  )
}

export default AdCopyIcon
